import React, { useState } from 'react';
import style from "./PBIDashboard.module.css"
import { Button } from 'react-bootstrap';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import RefreshIcon from '@mui/icons-material/Refresh';
import { callLogEvent } from '../../Util';


export interface PBIDashboardProps {
  title: any;
  dashboardURL: string;
  onPage: any;
}
const PBIDashboard = ({ title, dashboardURL, onPage }: PBIDashboardProps) => {
  const [zoomValue, setZoomValue] = useState(100);
  // "https://app.powerbi.com/reportEmbed?reportId=e3e956ba-cf8c-403e-9078-c48e463283be&appId=9959bc79-e8b1-4ec4-8111-75a5d31e0c5f&autoAuth=true&ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3"
  const increaseZoom = () => {
    if (zoomValue < 300) {
      setZoomValue(zoomValue + 25);
      callLogEvent("CLICKED_ON_"+onPage!.toUpperCase().trim().replaceAll(' ','_')+"_"+title.toUpperCase().trim().replaceAll(' ','_')+"_PBI_DASHBOARD_ZOOM_IN_BUTTON","clicked on PBI Dashboard zoom in button for value: "+zoomValue);
    }

  }
  const decreaseZoom = () => {
    if (zoomValue > 25) {
      setZoomValue(zoomValue - 25);
      callLogEvent("CLICKED_ON_"+onPage!.toUpperCase().trim().replaceAll(' ','_')+"_"+title.toUpperCase().trim().replaceAll(' ','_')+"_PBI_DASHBOARD_ZOOM_OUT_BUTTON","clicked on PBI Dashboard zoom out button for value: "+zoomValue);
    }
  }
  return <div className={style.dashboardContaier}>
    <span className='flex-content-space-between'>
      <span>
        <h4>{title}</h4>
      </span>
      <span>
        <Button className="emptyBtn" onClick={increaseZoom}><ZoomInIcon /></Button>
        <Button className="emptyBtn" onClick={decreaseZoom}><ZoomOutIcon /></Button>
        <Button className="emptyBtn" onClick={() => setZoomValue(100)}><RefreshIcon /></Button>
      </span>
    </span>
    <div style={{ zoom: zoomValue + '%', overflowY: 'scroll' }} >
      <iframe title="Executive Summary" className={style.iframeView} src={dashboardURL} allowFullScreen={true}></iframe>
    </div>
    {/* <div className={style.container} style={{ zoom: zoomValue + '%' }}>
      <iframe title="Executive Summary" className={style.responsiveIframe} src={dashboardURL} allowFullScreen={true}></iframe>
    </div> */}
  </div>
}

export default PBIDashboard;